import { useCustomerServiceApi } from "@/api/hooks/customerService.hook";
import { AddressValidationProvider } from "@/components/Address/AddressValidation/context/addressValidation.context";
import {
    broadcastMessage,
    clearMessageById
} from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import FranchiseRequest from "./franchiseRequest.component";
import { RequestFranchiseRequest } from "./franchiseRequest.types";

const FranchiseRequestContainer = () => {
    const { t } = useGranite();
    const [{ loading: isRequesting }, requestFranchise] =
        useCustomerServiceApi<RequestFranchiseRequest>(
            {
                url: "/franchises/contact",
                method: "POST"
            },
            { manual: true, useCache: false }
        );

    const onSubmit = (request: RequestFranchiseRequest): Promise<void> => {
        clearMessageById("franchise-request-success");
        return new Promise((resolve, reject) => {
            return requestFranchise({ data: request })
                .then(() => {
                    broadcastMessage({
                        id: "franchise-request-success",
                        text: t("franchise.request.success.message"),
                        status: "success",
                        dismissible: true,
                        activeScroll: true
                    });
                    resolve();
                })
                .catch(() => {
                    broadcastMessage({
                        id: "franchise-request-failure",
                        text: t("franchise.request.failure.message"),
                        status: "danger",
                        dismissible: true,
                        activeScroll: true
                    });
                    reject();
                });
        });
    };

    return (
        <AddressValidationProvider>
            <FranchiseRequest
                onSubmit={onSubmit}
                isLoading={isRequesting}
            />
        </AddressValidationProvider>
    );
};

export { FranchiseRequestContainer };
